import { styled } from '@mui/system';
import { IconButton, Typography } from '@mui/material';

export const UploadImageMessageContainer = styled('div')({
  padding: '8px 8px 8px 0',
});

export const UploadImageMessage = styled(Typography)(({ theme }) => ({
  fontWeight: 400,
  fontSize: '14px',
  letterSpacing: '0.15px',
  color: theme.palette.text.primary,
}));

export const UploadImagesScrollContainer = styled('div')({
  overflowX: 'scroll',
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  gap: '28px',
});

export const AddImageInput = styled('input')({
  display: 'none',
});

interface UploadButtonDivProps {
  error?: boolean;
}
export const AddImageDiv = styled('div')<UploadButtonDivProps>((props) => ({
  width: '100px',
  height: '100px',
  display: 'flex',
  borderRadius: '10px',
  position: 'relative',
  justifyContent: 'center',
  alignItems: 'center',
  cursor: 'pointer',
  border: props.error ? '1px dashed #D32F2F' : '1px dashed #0277BD',
  backgroundColor: props.error ? '#fbeaea' : '#F9F9F9',
}));

export const ErrorMessageContainer = styled('div')({
  minHeight: '21px',
});

export const UploadImageTextError = styled(Typography)({
  fontSize: '12px',
  color: '#D32F2F',
  textAlign: 'left',
});

export const UploadButtonDiv = styled('div', {
  shouldForwardProp: (prop) => prop !== 'error',
})<UploadButtonDivProps>(({ error }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '10px',
  cursor: 'pointer',
  padding: '20px 0px',
  ...(error
    ? {
        border: '1px solid #D32F2F',
        backgroundColor: '#fbeaea',
      }
    : {
        border: ' 1px solid #0A7ABE',
        backgroundColor: '#EFF7FF',
      }),
}));

interface UploadButtonIconProps {
  error?: boolean;
}
export const UploadButtonIcon = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== 'error',
})<UploadButtonIconProps>(({ error }) => ({
  padding: '0px',
  ...(error
    ? {
        color: '#D32F2F',
      }
    : {
        color: '#0A7ABE',
      }),
}));

interface UploadButtonTextProps {
  error?: boolean;
}
export const UploadButtonText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'error',
})<UploadButtonTextProps>(({ error }) => ({
  fontFamily: 'Poppins',
  fontWeight: 500,
  fontSize: '13px',
  lineHeight: '19.5px',
  letterSpacing: '0.16px',
  textAlign: 'center',
  marginBottom: '12px',
  margin: 0,
  ...(error
    ? {
        color: '#D32F2F',
      }
    : {
        color: '#0A7ABE',
      }),
}));
